const $ = require('jquery')

export const initializeVideoPopup = () => {
  $('.videopopup').magnificPopup({
    type: 'iframe'
  })
}
